
    import './styles.scoped.css';
    export default {
  "drawer": "awsui_drawer_1sxt8_pzj49_181",
  "header": "awsui_header_1sxt8_pzj49_214",
  "with-toolbar": "awsui_with-toolbar_1sxt8_pzj49_229",
  "header-actions": "awsui_header-actions_1sxt8_pzj49_247",
  "content-with-paddings": "awsui_content-with-paddings_1sxt8_pzj49_258",
  "test-utils-drawer-content": "awsui_test-utils-drawer-content_1sxt8_pzj49_265"
};
  